import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { Article } from "../support.types";

export type ArticleData = {
  article: Article;
};

/**
 * Fetches a single article by slug.
 * This fetches any published article regardless of category type,
 * useful for informational articles that aren't in the support collection.
 *
 * @param slug - The article slug to fetch
 * @param enabled - Whether to run the query (default: true if slug is provided)
 */
export function useFetchArticle(slug: string | null, enabled: boolean = true) {
  return useQuery({
    queryKey: ["article", slug],
    queryFn: () => apiRequest(`/article/${slug}/`, "GET", null, false),
    enabled: enabled && !!slug,
    select: (data): Article | null => {
      if (!data?.article) return null;
      return {
        id: data.article.slug, // Use slug as id for consistency with support articles
        title: data.article.title,
        slug: data.article.slug,
        excerpt: data.article.excerpt ?? "",
        content: data.article.content,
      };
    },
  });
}

export default useFetchArticle;
